import React from "react";
// proptypes
import PropTypes from "prop-types";

import { Footer } from "./styles";
export default function FooterPage({ children, orderResume }) {
  return (
    <Footer
      className={`d-flex justify-content-center align-items-center bg-white mt-3 mb-5 ${
        orderResume && "flex-column gap-2"
      }`}
    >
      {children}
    </Footer>
  );
}

FooterPage.propTypes = {
  children: PropTypes.node.isRequired,
  orderResume: PropTypes.bool,
};
